/* AdminDashboard.js با تغییرات پیشنهادی */

import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ServiceTable from "./ServiceTable";
import "./AdminDashboard.css";

function AdminDashboard() {
  const [adminLoggedIn, setAdminLoggedIn] = useState(false);

  // برای لاگین ادمین
  const navigate = useNavigate();
  const handleLogout = () => {
    localStorage.removeItem("adminToken");
    // در صورت وجود داده‌های دیگر برای ادمین
    localStorage.removeItem("userData");
    navigate("/login");
  };

  // stateهای قبلی
  const [pendingServices, setPendingServices] = useState([]);
  const [completedServices, setCompletedServices] = useState([]);
  const [archivedServices, setArchivedServices] = useState([]); // جدید
  const [filter, setFilter] = useState("Pending");
  const [searchQuery, setSearchQuery] = useState("");

  // modal برای تکمیل سرویس
  const [showCompleteForm, setShowCompleteForm] = useState(false);
  const [selectedService, setSelectedService] = useState(null);
  const [serviceDetails, setServiceDetails] = useState({
    serviceDate: "",
    serviceTime: "",
    serviceOperator: "",
    mileage: "",
    receivedAmount: ""
  });

  // کنترل ظاهر Modal Overlay
  const [showModalOverlay, setShowModalOverlay] = useState(false);

  // ایونت برای Pagination ساده
  const [page, setPage] = useState(1);
  const itemsPerPage = 5;

  // ==========================
  // 1) چک کردن اعتبار ادمین (مانند قبل)
  useEffect(() => {
    const checkAdminSession = () => {
    const adminToken = localStorage.getItem("userToken");

      const userData = JSON.parse(localStorage.getItem("userData"));
      if (adminToken && userData?.role === "admin") {
        setAdminLoggedIn(true);
      } else {
        setAdminLoggedIn(false);
      }
    };
    checkAdminSession();
    window.addEventListener("storage", checkAdminSession);
    return () => window.removeEventListener("storage", checkAdminSession);
  }, []);

  // ==========================
  // 2) دریافت سرویس‌ها (Pending, Completed)
  useEffect(() => {
    const fetchServices = async () => {
      try {
        const res = await fetch("https://carcure.ca/backend/get-services");
        if (!res.ok) throw new Error("Failed to fetch services");
        const data = await res.json();
        setPendingServices(data.pending || []);
        setCompletedServices(data.completed || []);
      } catch (error) {
        console.error("❌ Error fetching services:", error);
      }
    };
    fetchServices();
  }, []);

  // ==========================
  // 3) دریافت سرویس‌های آرشیوشده
  const fetchArchivedServices = async () => {
    try {
      const res = await fetch("https://carcure.ca/backend/get-archived-services");
      if (!res.ok) throw new Error("Failed to fetch archived services");
      const data = await res.json();
      setArchivedServices(data);
    } catch (error) {
      console.error("❌ Error fetching archived services:", error);
    }
  };

  // هر بار فیلتر = Archived شد، سرویس‌های آرشیو را بگیریم.
  useEffect(() => {
    if (filter === "Archived") {
      fetchArchivedServices();
    }
  }, [filter]);

  // --------------------------
  // توابع تکمیل سرویس
  const handleCompleteService = (service) => {
    if (!service || !service.Email) {
      console.error("❌ Invalid service selected:", service);
      return;
    }
    setSelectedService(service);
    setServiceDetails({
      serviceDate: "",
      serviceTime: "",
      serviceOperator: "",
      mileage: "",
      receivedAmount: ""
    });
    setShowCompleteForm(true);
    setShowModalOverlay(true);
  };

  const handleSubmitCompleteService = async () => {
    if (!serviceDetails.serviceDate || !serviceDetails.serviceTime || !serviceDetails.serviceOperator || !serviceDetails.mileage || !serviceDetails.receivedAmount) {
      alert("Please fill in all service completion fields.");
      return;
    }
    try {
      const response = await fetch("https://carcure.ca/backend/complete-service", {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email: selectedService.Email,
          requestedDate: selectedService["Requested Date"],
          requestedTime: selectedService["Requested Time"],
          serviceDate: serviceDetails.serviceDate,
          serviceTime: serviceDetails.serviceTime,
          serviceOperator: serviceDetails.serviceOperator,
          mileage: serviceDetails.mileage,
          receivedAmount: serviceDetails.receivedAmount
        })
      });
      if (!response.ok) throw new Error("Failed to complete service");

//*-------------------------------------------------------*//

   console.log("📤 Sending service completion email to:", selectedService.Email);
    await fetch("https://carcure.ca/backend/send-completion-email", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        to: selectedService.Email,
        name: selectedService.Name,
        serviceDate: serviceDetails.serviceDate,
        mileage: serviceDetails.mileage, 
        receivedAmount: serviceDetails.receivedAmount 
      })
    });



//*-------------------------------------------------------------------------*//




      // حذف از pending
      setPendingServices(prev =>
        prev.filter(p =>
          !(
            p.Email === selectedService.Email &&
            p["Requested Date"] === selectedService["Requested Date"] &&
            p["Requested Time"] === selectedService["Requested Time"]
          )
        )
      );

      // اضافه به completed
      setCompletedServices(prev => [
        ...prev,
        {
          ...selectedService,
          ...serviceDetails,
          Status: "Completed"
        }
      ]);

      setShowCompleteForm(false);
      setShowModalOverlay(false);
      alert("✅ Service completed successfully!");
    } catch (error) {
      console.error("❌ Error completing service:", error);
      alert("❌ Could not complete the service.");
    }
  };

  // توابع بستن فرم
  const handleCloseForm = () => {
    setShowCompleteForm(false);
    setShowModalOverlay(false);
  };

  // --------------------------
  // 4) توابع مربوط به آرشیو / بازگردانی
  const handleArchiveService = async (service) => {
  if (!service || !service.Email || !service["Requested Date"] || !service["Requested Time"]) {
  console.error("❌ Missing identification fields in service:", service);
  return;
}

try {
  const response = await fetch("https://carcure.ca/backend/archive-service", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      email: service.Email,
      requestedDate: service["Requested Date"],
      requestedTime: service["Requested Time"]
    })
  });
  if (!response.ok) throw new Error("Archive failed!");

  // حذف فقط رکوردی که با این سه فیلد مطابقت دارد
  setCompletedServices(prev =>
    prev.filter(s =>
      !(
        s.Email === service.Email &&
        s["Requested Date"] === service["Requested Date"] &&
        s["Requested Time"] === service["Requested Time"]
      )
    )
  );


  alert("✅ Service archived successfully!");
} catch (error) {
  console.error("❌ Error archiving service:", error);
  alert("❌ Could not archive service.");
}

};
      // حذف از completedServices
 
  const handleRestoreService = async (service) => {
if (!service || !service.Email || !service["Requested Date"] || !service["Requested Time"]) {
  console.error("❌ Missing identification fields in service:", service);
  return;
}

try {
  const response = await fetch("https://carcure.ca/backend/restore-service", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      email: service.Email,
      requestedDate: service["Requested Date"],
      requestedTime: service["Requested Time"]
    })
  });
  if (!response.ok) throw new Error("Restore failed!");

  // حذف فقط رکوردی که با این سه فیلد مطابقت دارد
  setArchivedServices(prev =>
    prev.filter(s =>
      !(
        s.Email === service.Email &&
        s["Requested Date"] === service["Requested Date"] &&
        s["Requested Time"] === service["Requested Time"]
      )
    )
  );
  alert("✅ Service restored successfully!");
} catch (error) {
  console.error("❌ Error restoring service:", error);
  alert("❌ Could not restore service.");
}

};
//-----------------------------------------

const handleReferService = async (service) => {
  // فرض کنید برای ارجاع، ایمیل سرویس‌کار را از کاربر می‌خواهید؛
  // یا اگر در رکورد وجود دارد، از آن استفاده کنید.
  const referralEmail = prompt("Enter referral email for this service:");
  if (!referralEmail) return;

  try {
    const response = await fetch("https://carcure.ca/backend/refer-service", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        email: service.Email,
        requestedDate: service["Requested Date"],
        requestedTime: service["Requested Time"],
        referralEmail
      })
    });
    if (!response.ok) throw new Error("Referral failed");
    alert("✅ Service referred successfully!");
    // بروز رسانی لیست سرویس‌های Pending (یا بخشی که سرویس ارجاع شده را نشان می‌دهد)
    // مثلاً می‌توانید سرویس ارجاع شده را از pendingServices حذف کنید یا وضعیت آن را تغییر دهید.
    setPendingServices(prev =>
      prev.map(s =>
        s.Email === service.Email &&
        s["Requested Date"] === service["Requested Date"] &&
        s["Requested Time"] === service["Requested Time"]
          ? { ...s, ReferralStatus: "Referred", ReferralEmail: referralEmail }
          : s
      )
    );
  } catch (error) {
    console.error("❌ Error referring service:", error);
    alert("❌ Could not refer service.");
  }
};


  // --------------------------
  // جستجو (Search)
  const filterServices = (servicesList) => {
    return servicesList.filter(service => {
      const q = searchQuery.toLowerCase();
      return (
        (service.Email || "").toLowerCase().includes(q) ||
        (service.Name || "").toLowerCase().includes(q) ||
        (service.Services || "").toLowerCase().includes(q)
      );
    });
  };

// شمارش تعداد دفعات سرویس برای هر ایمیل
const countServiceOccurrences = () => {
  const allServices = [...pendingServices, ...completedServices, ...archivedServices];
  const counts = {};
  allServices.forEach(service => {
    const email = service.Email;
    if (email) {
      counts[email] = (counts[email] || 0) + 1;
    }
  });
  return counts;
};

const serviceCounts = countServiceOccurrences();

  const filteredPending = filterServices(pendingServices);
  const filteredCompleted = filterServices(completedServices);
  const filteredArchived = filterServices(archivedServices);

  // --------------------------
  // 5) مرتب‌سازی (Sort) ساده بر اساس تاریخ یا مبلغ
  const [sortKey, setSortKey] = useState("Requested Date");
  const [sortOrder, setSortOrder] = useState("asc"); // یا "desc"

  const sortServices = (list) => {
    return [...list].sort((a, b) => {
      let valA = a[sortKey] || "";
      let valB = b[sortKey] || "";
      // اگر تاریخ است، تبدیل به Date
      if (sortKey.includes("Date")) {
        valA = new Date(valA).getTime();
        valB = new Date(valB).getTime();
      }
      if (valA < valB) return sortOrder === "asc" ? -1 : 1;
      if (valA > valB) return sortOrder === "asc" ? 1 : -1;
      return 0;
    });
  };

  const handleSortChange = (e) => {
    setSortKey(e.target.value);
  };

  const toggleSortOrder = () => {
    setSortOrder(prev => (prev === "asc" ? "desc" : "asc"));
  };

  // --------------------------
  // 6) Pagination ساده: Slice لیست
  const paginated = (list) => {
    const startIndex = (page - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return list.slice(startIndex, endIndex);
  };

 
  const nextPage = () => setPage(p => p + 1);
  const prevPage = () => setPage(p => Math.max(1, p - 1));

  useEffect(() => {
    setPage(1);
  }, [filter, searchQuery, sortKey, sortOrder]);

  // --------------------------
  // آماده‌سازی نهایی لیست‌ها با جستجو، مرتب‌سازی، صفحه‌بندی:
let visibleServices = [];
if (filter === "Pending") {
  visibleServices = sortServices(filteredPending);
} else if (filter === "Completed") {
  visibleServices = sortServices(filteredCompleted);
} else if (filter === "Archived") {
  visibleServices = sortServices(filteredArchived);
} else if (filter === "Referred") {
  visibleServices = sortServices(
    filterServices(pendingServices.filter(s => s.ReferralStatus === "Referred"))
  );
}
  const displayedServices = paginated(visibleServices);

  return (
    <div className="admin-dashboard">
      <h1>🛠 Admin Dashboard</h1>

      {/* اگر ادمین لاگین است، دکمه Logout را نمایش دهیم */}
      {adminLoggedIn && (
        <button className="logout-button" onClick={handleLogout}>
          Logout
        </button>
      )}

      {/* اگر داده‌ای وجود نداشت */}
      {pendingServices.length === 0 && completedServices.length === 0 && archivedServices.length === 0 ? (
        <p>🚀 No service data available. Check server connection.</p>
      ) : (
        <div>

<div className="dashboard-summary">
  <div>⏳ Pending: {pendingServices.length}</div>
  <div>✅ Completed: {completedServices.length}</div>
  <div>📦 Archived: {archivedServices.length}</div>
</div>


          {/* نوار جستجو و فیلتر */}
          <input
            type="text"
            placeholder="Search by name, email, service..."
            value={searchQuery}
            onChange={e => setSearchQuery(e.target.value)}
          />

        <select onChange={e => setFilter(e.target.value)} value={filter}>
  <option value="Pending">Pending Services</option>
  <option value="Completed">Completed Services</option>
  <option value="Archived">Archived Services</option>
  <option value="Referred">Referred Services</option>
</select>


          {/* مرتب‌سازی */}
          <select onChange={handleSortChange} value={sortKey}>
            <option value="Requested Date">Requested Date</option>
            <option value="Service Date">Service Date</option>
            <option value="Total Price">Total Price</option>
          </select>
          <button onClick={toggleSortOrder}>
            {sortOrder === "asc" ? "Asc ↗" : "Desc ↘"}
          </button>

          {/* نمایش رکوردهای فیلترشده و مرتب‌شده */}
         <ServiceTable
  services={displayedServices}
 serviceCounts={serviceCounts}
  title={
    filter === "Pending"
      ? "🚗 Pending Services"
      : filter === "Completed"
      ? "✅ Completed Services"
      : "📦 Archived Services"
  }
  isPending={filter === "Pending"}
  isArchived={filter === "Archived"}
  handleCompleteService={handleCompleteService}
  handleArchiveService={handleArchiveService}
  handleRestoreService={handleRestoreService}
  handleReferService={handleReferService}   // اضافه شده!
/>


          {/* دکمه‌های Pagination */}
          <div className="pagination">
            <button onClick={prevPage} disabled={page === 1}>Prev</button>
            <span>Page {page}</span>
            <button
              onClick={nextPage}
              disabled={page * itemsPerPage >= visibleServices.length}
            >
              Next
            </button>
          </div>
        </div>
      )}

      {/* Modal Overlay */}
      {showModalOverlay && (
        <div className="modal-overlay" onClick={handleCloseForm}></div>
      )}

      {/* فرم تکمیل سرویس */}
      {showCompleteForm && selectedService && (
        <div className="modal">
          <h2>Complete Service</h2>

          <label>Service Date:</label>
          <input
            type="date"
            value={serviceDetails.serviceDate}
            onChange={e => setServiceDetails({ ...serviceDetails, serviceDate: e.target.value })}
          />

          <label>Service Time:</label>
          <input
            type="time"
            value={serviceDetails.serviceTime}
            onChange={e => setServiceDetails({ ...serviceDetails, serviceTime: e.target.value })}
          />

          <label>Service Operator:</label>
          <input
            type="text"
            placeholder="Operator Name"
            value={serviceDetails.serviceOperator}
            onChange={e => setServiceDetails({ ...serviceDetails, serviceOperator: e.target.value })}
          />

          <label>Mileage:</label>
          <input
            type="number"
            placeholder="Mileage"
            value={serviceDetails.mileage}
            onChange={e => setServiceDetails({ ...serviceDetails, mileage: e.target.value })}
          />

          <label>Received Amount ($):</label>
          <input
            type="number"
            placeholder="Amount"
            value={serviceDetails.receivedAmount}
            onChange={e => setServiceDetails({ ...serviceDetails, receivedAmount: e.target.value })}
          />

          <button onClick={handleSubmitCompleteService}>Confirm</button>
          <button onClick={handleCloseForm}>Cancel</button>
        </div>
      )}
    </div>
  );
}

export default AdminDashboard;